import React, { useMemo } from 'react';
import { parseJobDescription } from '../../utils/parseJobDescription';
import './JobDescriptionContent.css';

const JobDescriptionContent = ({ content, emptyMessage = 'No description provided' }) => {
  const parsed = useMemo(() => parseJobDescription(content), [content]);

  if (parsed.mode === 'empty') {
    return <p className="job-description-empty">{emptyMessage}</p>;
  }

  if (parsed.mode === 'html') {
    return (
      <div
        className="job-description-content job-description-content--html"
        dangerouslySetInnerHTML={{ __html: parsed.html || content }}
      />
    );
  }

  return (
    <div className="job-description-content job-description-content--structured">
      {parsed.sections.map((section, sectionIndex) => (
        <div
          key={`${section.key}-${sectionIndex}`}
          className={`job-description-block job-description-block--${section.key}`}
        >
          <div className="job-description-block-title">{section.title}</div>

          {section.items && section.items.length > 0 ? (
            <ul className="job-description-list">
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          ) : (
            <div className="job-description-body">
              {(section.paragraphs || []).map((paragraph, paragraphIndex) => (
                <p key={paragraphIndex}>{paragraph}</p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default JobDescriptionContent;
